<template>
    <ajax-form
        :action="route('front.api.customer-service.create-ticket')"
        class="w-full"
        :submit-btn-classes="submitButtonClasses"
        @error="$EventBus.$emit('resetCaptcha')"
    >
        <input
            type="hidden"
            name="customer_type"
            :value="customerType"
        >
        <div class="grid">
            <div class="column w-full md:w-1/2">
                <text-input
                    v-model="name"
                    :label="lang('Namn','Name')"
                    name="name"
                    :validations="'required'"
                    :required="true"
                />
            </div>
            <div class="column w-full md:w-1/2">
                <text-input
                    v-model="email"
                    :label="lang('E-postadress','E-mail')"
                    name="email"
                    :validations="'required|email'"
                    :required="true"
                />
            </div>
        </div>
        <div class="grid">
            <div class="column w-full md:w-1/2">
                <select-input
                    v-model="selectedGroup"
                    :options="groups"
                    name="group"
                    :validations="'required'"
                    :placeholder="lang('Vad kan vi hjälpa till med?', 'How can we help you?')"
                    :required="true"
                />
            </div>
            <div class="column w-full md:w-1/2">
                <text-input
                    v-model="uniqueExternalId"
                    :label="lang('Kundnummer','Customer number')"
                    name="unique_external_id"
                />
            </div>
        </div>
        <text-input
            v-model="subject"
            :label="lang('Ämne','Subject')"
            name="subject"
            :validations="'required|min:1'"
            :required="true"
        />
        <textarea-input
            v-model="description"
            :label="lang('Skriv ditt meddelande här...','Your message...')"
            name="description"
            :required="true"
        />
        <div class="form-group" :class="{ 'opacity-50': freeze }">
            <file-input
                :label="lang('Filer', 'Files')"
                name="attachments[]"
            />
        </div>
        <div
            v-if="siteKey"
            class="form-group"
            :class="{ 'opacity-50': freeze }"
        >
            <friendly-captcha
                :site-key="siteKey"
                :use-eu-endpoint="captchaUseEuEndpoint"
            />
        </div>
    </ajax-form>
</template>

<script>
export default {
    props: {
        groups: {
            type: Array,
            required: true,
        },
        siteKey: {
            type: [String, null],
            default: null,
        },
        captchaUseEuEndpoint: {
            type: Boolean,
            default: false,
        },
        customerType: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            selectedGroup: '',
            email: null,
            personalIdentityNumber: null,
            uniqueExternalId: null,
            subject: '',
            description: '',
            name: '',
            loading: false,
            freeze: false,
            terminationModalName: 'termination-info-modal',
        };
    },
    computed: {
        submitButtonClasses() {
            let classes = 'float-right';
            if (this.freeze) {
                classes += ' disabled pointer-events-none';
            }

            return classes;
        },
    },
    methods: {
        hideTerminationModal() {
            this.$modal.hide(this.terminationModalName);
        },
    },
};
</script>
